import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//SERVICE
import { TUpdateStatusPayload } from '../../../sales-order/interfaces/sales-order.interface';
import { EnvironmentUtilService } from '../util/environment-util.service';

import { ApiService } from './api.service';

//INTERFACE

@Injectable({
  providedIn: 'root',
})
export class SalesOrderApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  createOrder(payload :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/sales/business-account`,
      body: {
        ...payload,
      },
    });
  }

  updateOrder(payload :any, salesOrderId :number) :Observable<any> {
    const url = `${this.environment.urlV2}/orders/sales/business-account/${salesOrderId}`;

    return this.apiService.put(url, payload);
  }

  get(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/sales/shipstation_sales/sales_orders`,
      { params },
    );
  }

  getLineItems(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/orders/sales/items`, {
      params,
    });
  }

  getRawProductsByLineItemId(data :{
    id :number;
    params :{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { id, params } = data;

    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/items/${id}`,
      { params },
    );
  }

  getSalesOrdersPickingItems(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/sales/shipstation_sales/sales_order/picking_items`,
      { params },
    );
  }

  bulkUpdateOrderStatus(payload :TUpdateStatusPayload) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV1}/sales/shipstation_sales/update-order-status`,
      body: {
        ...payload,
      },
    });
  }

  pullOrders(appIntegrationAccountIds :number[]) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/sales/pull-orders`,
      body: {
        appIntegrationAccountIds,
      },
    });
  }

  pullOrder(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/pull-order`,
      { params },
    );
  }

  exportBulkSalesOrder(params ?:{
    [key :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.getBlob(
      `${this.environment.urlV2}/orders/sales/bulk-export`,
      {
        params: params,
      },
    );
  }

  exportFulfillmentAllocationSheet(salesOrderIds :number[]) :Observable<any> {
    return this.apiService.getBlob(
      `${this.environment.urlV2}/orders/sales/fulfillment-allocation-sheet`,
      {
        params: { salesOrderIds: salesOrderIds.join(',') },
      },
    );
  }

  getNextOrderNumber(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/orders/sales/next-order-number`,
      { params },
    );
  }
}
